import {
  ReportTooltipTemplateContext,
  ReportsTranslations,
  DatasetBase,
  ReportTooltipNormalizedParams,
} from '@core/reports-types';
import { datasetTooltipFormatterOptions } from '@core/reports-util';
import { valueFormatter } from '@core/utils-legacy';
const getTotals = (dataset: DatasetBase) => dataset.calcTotals().map(([, total]) => total);

export const timeBasedTooltipContextFactory = (
  dataset: DatasetBase,
  translations: ReportsTranslations,
  params: ReportTooltipNormalizedParams,
): ReportTooltipTemplateContext => {
  const totals = getTotals(dataset);

  const items = params.reduce(
    (acc, param) => {
      acc.push({
        label: dataset.getCategoryNameById(params[0].name),
        value: valueFormatter(
          totals[params[0].dataIndex],
          datasetTooltipFormatterOptions(dataset),
          translations.i18n,
        ),
        color: <string>param.color,
      });

      return acc;
    },
    <ReportTooltipTemplateContext['items']>[],
  );

  return {
    footerPrimaryText: undefined,
    footerSecondaryText: undefined,
    headerText: dataset.metric.xAxis,
    items,
  };
};
